import {css, cva} from "@panda/css";

import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {RESERVATION_CODE_LENGTH} from "../constants/reservation_constants";
import {useReservationCodeInputs} from "../hooks/use_reservation_code_inputs";

interface IProps {
    digits: string[];
    titleId: string;
    describedById?: string;
    hasError: boolean;
    disabled: boolean;
    // bumped whenever the first input should take focus
    focusRequestId: number;
    onChange: (digits: string[]) => void;
    // called once per change that leaves every input filled
    onComplete: (code: string) => void;
}

export const ReservationCodeInputs = (props: IProps) => {
    const {digits, titleId, describedById, hasError, disabled, focusRequestId, onChange, onComplete} = props;
    const {currentDigits, setInputRef, handleChange, handleKeyDown, handlePaste} = useReservationCodeInputs({
        digits,
        disabled,
        focusRequestId,
        onChange,
        onComplete
    });

    return (
        <div className={inputsRowStyle} role="group" aria-labelledby={titleId}>
            {currentDigits.map((digit, index) => (
                <input
                    key={index}
                    ref={setInputRef(index)}
                    value={digit}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    // the code autofilled from the e-mail lands in the first input and is spread over the rest
                    autoComplete={index === 0 ? "one-time-code" : "off"}
                    // room for a digit typed next to the one an input holds - the selection made on focus does not survive a tap in WebKit
                    maxLength={RESERVATION_CODE_LENGTH}
                    aria-label={`Cyfra ${index + 1} z ${RESERVATION_CODE_LENGTH}`}
                    aria-invalid={hasError}
                    aria-describedby={describedById}
                    disabled={disabled}
                    className={digitInputStyle({hasError})}
                    onChange={(event) => handleChange(index, event.target.value)}
                    onKeyDown={(event) => handleKeyDown(index, event)}
                    onPaste={(event) => handlePaste(index, event)}
                    onFocus={(event) => event.target.select()}
                    data-testid={RP_RESERVATION_TEST_IDS.GET_CODE_INPUT(index)}
                />
            ))}
        </div>
    );
};

const inputsRowStyle = css({
    display: "flex",
    justifyContent: "space-between",
    columnGap: 1
});

const digitInputStyle = cva({
    base: {
        flex: "1 1 0",
        minWidth: 0,
        maxWidth: "7.2rem",
        aspectRatio: "1 / 1",
        p: 0,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "var(--colors-secondary)",
        borderRadius: 1,
        backgroundColor: "var(--colors-white)",
        color: "var(--colors-secondary)",
        fontSize: "3.079rem",
        fontWeight: 600,
        lineHeight: 1,
        textAlign: "center",
        outline: "none",
        appearance: "none",
        _focus: {
            boxShadow: "inset 0 0 0 1px var(--colors-secondary)"
        },
        _disabled: {
            opacity: 0.6,
            cursor: "default"
        }
    },
    variants: {
        hasError: {
            true: {
                borderColor: "var(--colors-danger)",
                _focus: {
                    boxShadow: "inset 0 0 0 1px var(--colors-danger)"
                }
            }
        }
    }
});
import {css, cva} from "@panda/css";

import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {RESERVATION_CODE_LENGTH} from "../constants/reservation_constants";
import {useReservationCodeInputs} from "../hooks/use_reservation_code_inputs";

interface IProps {
    digits: string[];
    titleId: string;
    describedById?: string;
    hasError: boolean;
    disabled: boolean;
    // bumped whenever the first input should take focus
    focusRequestId: number;
    onChange: (digits: string[]) => void;
    // called once per change that leaves every input filled
    onComplete: (code: string) => void;
}

export const ReservationCodeInputs = (props: IProps) => {
    const {digits, titleId, describedById, hasError, disabled, focusRequestId, onChange, onComplete} = props;
    const {currentDigits, setInputRef, handleChange, handleKeyDown, handlePaste} = useReservationCodeInputs({
        digits,
        disabled,
        focusRequestId,
        onChange,
        onComplete
    });

    return (
        <div className={inputsRowStyle} role="group" aria-labelledby={titleId}>
            {currentDigits.map((digit, index) => (
                <input
                    key={index}
                    ref={setInputRef(index)}
                    value={digit}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    // the code autofilled from the e-mail lands in the first input and is spread over the rest
                    autoComplete={index === 0 ? "one-time-code" : "off"}
                    // room for a digit typed next to the one an input holds - the selection made on focus does not survive a tap in WebKit
                    maxLength={RESERVATION_CODE_LENGTH}
                    aria-label={`Cyfra ${index + 1} z ${RESERVATION_CODE_LENGTH}`}
                    aria-invalid={hasError}
                    aria-describedby={describedById}
                    disabled={disabled}
                    className={digitInputStyle({hasError})}
                    onChange={(event) => handleChange(index, event.target.value)}
                    onKeyDown={(event) => handleKeyDown(index, event)}
                    onPaste={(event) => handlePaste(index, event)}
                    onFocus={(event) => event.target.select()}
                    data-testid={RP_RESERVATION_TEST_IDS.GET_CODE_INPUT(index)}
                />
            ))}
        </div>
    );
};

const inputsRowStyle = css({
    display: "flex",
    justifyContent: "space-between",
    columnGap: 1
});

const digitInputStyle = cva({
    base: {
        flex: "1 1 0",
        minWidth: 0,
        maxWidth: "7.2rem",
        aspectRatio: "1 / 1",
        p: 0,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "var(--colors-secondary)",
        borderRadius: 1,
        backgroundColor: "var(--colors-white)",
        color: "var(--colors-secondary)",
        fontSize: "3.079rem",
        fontWeight: 600,
        lineHeight: 1,
        textAlign: "center",
        outline: "none",
        appearance: "none",
        _focus: {
            boxShadow: "inset 0 0 0 1px var(--colors-secondary)"
        },
        _disabled: {
            opacity: 0.6,
            cursor: "default"
        }
    },
    variants: {
        hasError: {
            true: {
                borderColor: "var(--colors-danger)",
                _focus: {
                    boxShadow: "inset 0 0 0 1px var(--colors-danger)"
                }
            }
        }
    }
});
